(function () {
  if (window.__teaQuizResetModule) return;

  (function redirectQuizPaths() {
  var path = (window.location.pathname || '').replace(/\/$/, '') || '/';
  if (path === '/quiz') {
    window.location.replace(window.location.origin + '/pages/taishitsu-check');
    return;
  }
  })();

  (function bootConstitutionHubGuard() {
    if (window.__teaQuizHubIsResultGuardV1) return;
    window.__teaQuizHubIsResultGuardV1 = 1;

    function constitutionHubHandledByLiveFix() {
      return !!(
        window.__teaQuizRenderConstitutionHub ||
        (window.__teaQuizConstitutionLiveFixBuild >= 12) ||
        window.__teaQuizConstitutionLiveFixV2
      );
    }

    function injectHubResultsRescueCssEarly() {
      if (document.getElementById('tea-quiz-hub-results-rescue-css')) return;
      var style = document.createElement('style');
      style.id = 'tea-quiz-hub-results-rescue-css';
      style.textContent =
        'html.quiz-results-from-quiz #quiz,' +
        'html.quiz-results-from-quiz #quiz-container,' +
        'html.quiz-results-from-quiz #shadow-quiz,' +
        'html.quiz-results-from-quiz .shopify-section:has(#quiz),' +
        'html.quiz-results-from-quiz .shopify-section:has(#shadow-quiz){display:none!important;}' +
        'html.quiz-results-from-quiz .quiz-constitution-results-section,' +
        'html.quiz-results-from-quiz #quiz-results,' +
        'html.quiz-results-from-quiz [data-quiz-constitution-results]{display:block!important;}';
      document.head.appendChild(style);
    }

    if (constitutionHubHandledByLiveFix()) {
      injectHubResultsRescueCssEarly();
      return;
    }

    var HUB_VIEW = 'quiz-results';
    var STORAGE_KEY = 'teaQuizConstitutionResults';
    var CONSTITUTION_NAMES = ['気虚', '血虚', '気滞', '陰虚', '陽虚', '痰湿', '瘀血', '平和'];

    window.__teaQuizHubRedirectLock = 0;
    try {
      sessionStorage.removeItem('teaQuizHubRedirectLock');
    } catch (error) {}

    function getRoot() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root.charAt(root.length - 1) === '/' ? root : root + '/';
    }

    function escapeHtml(text) {
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function buildHubUrl() {
      return getRoot() + '#quiz-results';
    }

    function buildDetailUrl(name) {
      return getRoot() + 'collections/' + encodeURIComponent(name) + '?from=quiz&view=detail#constitution-info';
    }

    function shouldSkipHubTransition() {
      if (window.__teaQuizLooksLikeResult && window.__teaQuizLooksLikeResult()) return false;
      if (window.location.hash === '#quiz') return true;
      if (document.documentElement.classList.contains('tea-quiz-take-mode')) return true;
      try {
        if (window.location.search.indexOf('_teaquizretake=') >= 0) return true;
        if (sessionStorage.getItem('teaQuizBlockRedirect') === '1') return true;
        if (sessionStorage.getItem('teaQuizExplicitRetake') === '1') return true;
        if (sessionStorage.getItem('teaQuizDismissedUntilRetake') === '1') return true;
      } catch (error) {}
      return false;
    }

    function injectHubResultsRescueCss() {
      if (document.getElementById('tea-quiz-hub-results-rescue-css')) return;
      var style = document.createElement('style');
      style.id = 'tea-quiz-hub-results-rescue-css';
      style.textContent =
        'html.quiz-results-from-quiz #quiz,' +
        'html.quiz-results-from-quiz #quiz-container,' +
        'html.quiz-results-from-quiz #shadow-quiz,' +
        'html.quiz-results-from-quiz .shopify-section:has(#quiz),' +
        'html.quiz-results-from-quiz .shopify-section:has(#shadow-quiz){display:none!important;}' +
        'html.quiz-results-from-quiz .quiz-constitution-results-section,' +
        'html.quiz-results-from-quiz #quiz-results,' +
        'html.quiz-results-from-quiz [data-quiz-constitution-results]{display:block!important;}';
      document.head.appendChild(style);
    }

    function hideQuizResultSurface() {
      document.documentElement.classList.add('quiz-results-from-quiz');
      document
        .querySelectorAll(
          '#shadow-quiz, #quiz #shadow-quiz, #quiz-container #shadow-quiz, #quiz, #quiz-container, .shopify-section:has(#quiz), .shopify-section:has(#shadow-quiz)'
        )
        .forEach(function (node) {
          node.style.setProperty('display', 'none', 'important');
        });
    }

    function readLiveScores() {
      if (window.Quiz && window.Quiz.variableScores) return window.Quiz.variableScores;
      if (window.quiz && window.quiz.variableScores) return window.quiz.variableScores;
      if (window.quiz && window.quiz.variables && window.quiz.variables.scores) {
        return window.quiz.variables.scores;
      }
      return null;
    }

    function captureResults() {
      var scores = readLiveScores();
      if (!scores) return null;
      var list = [];
      CONSTITUTION_NAMES.forEach(function (name) {
        var score = Number(scores[name] || 0);
        if (score >= 9) list.push({ name: name, score: score, percent: 0 });
      });
      if (!list.length) return null;
      list.sort(function (a, b) {
        return b.score - a.score;
      });
      if (list.length === 1) {
        list[0].percent = 100;
      } else {
        var total = 0;
        list.forEach(function (item) {
          total += item.score;
        });
        var assigned = 0;
        list.forEach(function (item, index) {
          if (index === list.length - 1) {
            item.percent = Math.max(0, 100 - assigned);
            return;
          }
          item.percent = total > 0 ? Math.round((item.score / total) * 100) : 0;
          assigned += item.percent;
        });
      }
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ qualified: list, savedAt: Date.now() }));
        sessionStorage.setItem('teaQuizRawScores', JSON.stringify(scores));
      } catch (error) {}
      return { qualified: list };
    }

    function readPersistedResults() {
      try {
        var raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        if (!parsed || !Array.isArray(parsed.qualified) || !parsed.qualified.length) return null;
        return parsed;
      } catch (error) {
        return null;
      }
    }

    function renderHubCards(root) {
      if (!root || root.querySelector('.quiz-constitution-results__grid')) return;
      if (root.querySelector('.quiz-constitution-results__toc-wrap')) return;
      if (root.querySelector('.quiz-constitution-results__detail-section')) return;
      if (window.__teaQuizRenderConstitutionHub) return;
      var data = readPersistedResults();
      if (!data) return;
      var cards = data.qualified
        .map(function (item) {
          var percent = typeof item.percent === 'number' ? item.percent : 0;
          return (
            '<a class="quiz-constitution-results__card" href="' +
            escapeHtml(buildDetailUrl(item.name)) +
            '"><span class="quiz-constitution-results__card-name">' +
            escapeHtml(item.name) +
            '</span><span class="quiz-constitution-results__card-percent">' +
            escapeHtml(String(percent)) +
            '<span class="quiz-constitution-results__card-percent-sign">%</span></span><span class="quiz-constitution-results__card-action">くわしく見る</span></a>'
          );
        })
        .join('');
      root.innerHTML =
        '<div class="quiz-constitution-results__inner page-width"><header class="quiz-constitution-results__header quiz-constitution-results__header--showcase" data-hub-heading-version="3">' +
        '<h1 class="quiz-constitution-results__title quiz-constitution-results__title--main">体質チェックの結果</h1>' +
        '<p class="quiz-constitution-results__lead">回答内容から、9点以上となった体質を表示しています。気になる体質をタップして、説明とおすすめのお茶をご覧ください。</p></header>' +
        '<div class="quiz-constitution-results__grid">' +
        cards +
        '</div><p class="quiz-constitution-results__note">※ パーセントは、該当した体質のスコア合計に対する割合です。</p></div>';
      root.dataset.rendered = 'true';
    }

    function paintHubSection() {
      var root =
        document.querySelector('.quiz-constitution-results-section [data-quiz-constitution-results]') ||
        document.querySelector('#quiz-results [data-quiz-constitution-results]') ||
        document.querySelector('[data-quiz-constitution-results]');
      if (!root) return;
      renderHubCards(root);
    }

    function ensureHubModule() {
      if (window.TeaQuizConstitutionHub) return;
      var ref = document.querySelector('script[src*="tea-quiz-reset.js"]');
      var base = ref && ref.src ? ref.src.replace(/[^/]+$/, '') : getRoot() + 'cdn/shop/t/8/assets/';
      if (document.querySelector('script[src*="tea-quiz-constitution-hub-v13"]') || document.querySelector('script[src*="tea-quiz-constitution-hub-v6"]')) {
        return;
      }
      var script = document.createElement('script');
      script.src = base + 'tea-quiz-constitution-hub-v13.js?_=' + Date.now();
      script.async = false;
      document.head.appendChild(script);
    }

    function triggerHubTransition() {
      if (shouldSkipHubTransition()) return;
      injectHubResultsRescueCss();
      hideQuizResultSurface();

      var path = (window.location.pathname || '').replace(/\/$/, '') || '/';
      var rootPath = getRoot().replace(/\/$/, '') || '/';
      if (path === '/' || path === rootPath) {
        try {
          history.replaceState(null, '', buildHubUrl());
        } catch (error) {}
      }

      captureResults();
      paintHubSection();
      ensureHubModule();

      if (window.__teaQuizTriggerConstitutionHub) {
        window.__teaQuizTriggerConstitutionHub();
        return;
      }
      if (window.TeaQuizConstitutionHub && window.TeaQuizConstitutionHub.showHubInPlace) {
        window.TeaQuizConstitutionHub.showHubInPlace();
        return;
      }
      if (window.__teaQuizPaintHubNow) {
        window.__teaQuizPaintHubNow();
      }

      window.setTimeout(paintHubSection, 300);
      window.setTimeout(paintHubSection, 1200);
    }

    window.__teaQuizTryRedirectToResultsHub = function () {
      triggerHubTransition();
      return true;
    };

    window.__teaQuizIsOnHubResultsPage = function () {
      try {
        return new URLSearchParams(window.location.search).get('view') === HUB_VIEW;
      } catch (error) {
        return window.location.search.indexOf('view=' + HUB_VIEW) !== -1;
      }
    };

    window.__teaQuizTriggerConstitutionHub = triggerHubTransition;

    window.addEventListener(
      'message',
      function (event) {
        var data = event.data;
        if (!data || data.channel !== 'revenuehunt:quiz-renderer' || data.type !== 'isResult') return;
        if (window.__teaQuizClearRetakeSessionFlags) {
          window.__teaQuizClearRetakeSessionFlags();
        } else {
          try {
            sessionStorage.removeItem('teaQuizExplicitRetake');
            sessionStorage.removeItem('teaQuizBlockRedirect');
          } catch (error) {}
        }
        if (shouldSkipHubTransition()) return;
        event.stopImmediatePropagation();
        triggerHubTransition();
      },
      true
    );

    injectHubResultsRescueCss();
    try {
      if (new URLSearchParams(window.location.search).get('view') === HUB_VIEW) {
        triggerHubTransition();
      }
    } catch (error) {}
  })();

  window.__teaQuizResetModule = 5;

  var RETakePattern = /やりなお|やり直|再チェック|retake|restart|最初から|start over/i;
  var StorageKeyPattern = /revenue.?hunt|revenuehunt|^prq|quiz-response|quiz_response|rh-quiz|rh_/i;

  function getCleanRootUrl() {
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root_url) || '/';
    return rootUrl.split('?')[0] || '/';
  }

  function isOnHomePath() {
    var cleanRoot = getCleanRootUrl();
    if (cleanRoot !== '/') {
      return window.location.pathname === cleanRoot;
    }
    return window.location.pathname === '/' || window.location.pathname === '';
  }

  function isQuizPagePath() {
    if (window.__teaQuizIsQuizPagePath) {
      return window.__teaQuizIsQuizPagePath();
    }
    var path = (window.location.pathname || '').replace(/\/$/, '') || '/';
    var cleanRoot = getCleanRootUrl().replace(/\/$/, '') || '/';
    return path === '/pages/taishitsu-check' || path === '/quiz' || path === cleanRoot + '/pages/taishitsu-check';
  }

  function scrollToTopHard() {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    var scrollToTop = function () {
      window.scrollTo(0, 0);
      if (document.documentElement) document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
    };
    scrollToTop();
    window.requestAnimationFrame(scrollToTop);
    window.setTimeout(scrollToTop, 50);
    window.setTimeout(scrollToTop, 200);
    window.setTimeout(scrollToTop, 500);
  }

  function markQuizHomeReset() {
    try {
      localStorage.setItem('teaQuizHomeReset', '1');
      sessionStorage.setItem('teaQuizDismissedUntilRetake', '1');
      sessionStorage.setItem('teaQuizReturnHome', '1');
    } catch (error) {}
    document.documentElement.classList.add('tea-quiz-at-home');
    if (document.body) document.body.classList.add('tea-quiz-at-home');
  }

  function allowQuizRestore() {
    try {
      localStorage.removeItem('teaQuizHomeReset');
      sessionStorage.removeItem('teaQuizDismissedUntilRetake');
      sessionStorage.removeItem('teaQuizSkipRestore');
    } catch (error) {}
    document.documentElement.classList.remove('tea-quiz-at-home');
    if (document.body) document.body.classList.remove('tea-quiz-at-home');
  }

  function hasPersistedConstitutionResults() {
    try {
      return !!(
        sessionStorage.getItem('teaQuizConstitutionResults') ||
        localStorage.getItem('teaQuizConstitutionResults')
      );
    } catch (error) {
      return false;
    }
  }

  function isHubResultsUrlNow() {
    if (window.location.search.indexOf('view=quiz-results') >= 0) return true;
    if (window.location.hash === '#quiz-results') return true;
    try {
      return new URLSearchParams(window.location.search).get('view') === 'quiz-results';
    } catch (error) {
      return false;
    }
  }

  function isQuizResultsHubActive() {
    var path = (window.location.pathname || '').replace(/\/$/, '') || '/';
    var cleanRoot = getCleanRootUrl().replace(/\/$/, '') || '/';
    if (path === '/pages/taishitsu-check-results' || path === cleanRoot + '/pages/taishitsu-check-results') return true;
    if (document.documentElement.classList.contains('quiz-results-from-quiz')) return true;
    if (document.documentElement.classList.contains('tea-quiz-hub-pending')) return true;
    if (document.documentElement.classList.contains('tea-quiz-hub-ready')) return true;
    return isHubResultsUrlNow();
  }

  function shouldApplyQuizHomeResetOnLoad() {
    if (window.location.search.indexOf('_teahome=') >= 0) return true;
    if (isHubResultsUrlNow()) return false;
    try {
      return (
        localStorage.getItem('teaQuizHomeReset') === '1' ||
        sessionStorage.getItem('teaQuizReturnHome') === '1'
      );
    } catch (error) {
      return false;
    }
  }

  function clearHubNavigationFlags() {
    try {
      sessionStorage.removeItem('teaQuizHubReturnPending');
      sessionStorage.removeItem('teaQuizHubActive');
      sessionStorage.removeItem('teaQuizReturnHome');
      localStorage.removeItem('teaQuizHubActive');
    } catch (error) {}
    window.__teaQuizHubHistoryPushed = 0;
    if (window.__teaQuizClearHubRedirectLock) {
      window.__teaQuizClearHubRedirectLock();
    }
  }

  function releaseHubModeAfterUrlClean() {
    window.__teaQuizResolvedPageMode = 'home';
    window.__teaQuizHubTransitionDone = 0;
    window.__teaQuizHubTransitionInProgress = 0;
    window.__teaQuizHubScrolledOnce = 0;
    if (window.__teaQuizApplyNormalHomeShell) {
      window.__teaQuizApplyNormalHomeShell();
    }
    exitQuizResultsMode();
    if (window.__teaQuizShowNormalHomepageQuiz) {
      window.__teaQuizShowNormalHomepageQuiz();
    } else if (window.__teaQuizRestoreHomepageQuiz) {
      window.__teaQuizRestoreHomepageQuiz();
    }
    try {
      localStorage.removeItem('teaQuizHomeReset');
      sessionStorage.removeItem('teaQuizReturnHome');
    } catch (error) {}
  }

  function releaseHubModeForLogo() {
    markQuizHomeReset();
    clearHubNavigationFlags();
    releaseHubModeAfterUrlClean();
  }

  function shouldBlockQuizRestore() {
    try {
      return sessionStorage.getItem('teaQuizDismissedUntilRetake') === '1';
    } catch (error) {
      return false;
    }
  }

  function quizResultsVisibleOnPage() {
    if (document.getElementById('quiz-container')) return true;
    if (window.location.hash === '#quiz') return true;

    var hosts = document.querySelectorAll('#quiz #shadow-quiz, #quiz-container #shadow-quiz, #shadow-quiz');
    for (var i = 0; i < hosts.length; i++) {
      var shadowRoot = hosts[i].shadowRoot;
      if (!shadowRoot) continue;
      if (shadowRoot.querySelector('.quiz-result')) return true;
      if (shadowRoot.querySelector('[data-tea-quiz-injected-popup], [data-tea-quiz-injected-inline]')) return true;
    }

    var inlineQuiz = document.getElementById('quiz');
    if (inlineQuiz && inlineQuiz.querySelector('a[href*="/products/"]')) return true;

    return false;
  }

  function clearConstitutionQuizStorage() {
    if (window.__teaQuizClearConstitutionResults) {
      window.__teaQuizClearConstitutionResults();
    }
    try {
      sessionStorage.removeItem('teaQuizConstitutionResults');
      sessionStorage.removeItem('teaQuizRawScores');
      sessionStorage.removeItem('teaQuizAnswerLog');
      sessionStorage.removeItem('teaQuizHubActive');
      sessionStorage.removeItem('teaQuizHubReturnPending');
      localStorage.removeItem('teaQuizConstitutionResults');
      localStorage.removeItem('teaQuizRawScores');
      localStorage.removeItem('teaQuizAnswerLog');
      localStorage.removeItem('teaQuizHubActive');
    } catch (error) {}
  }

  function clearSavedConstitutionForLogoHome() {
    clearConstitutionQuizStorage();
    try {
      sessionStorage.removeItem('teaQuizReturnHome');
      sessionStorage.removeItem('teaQuizHubRedirectLock');
      sessionStorage.removeItem('teaQuizDismissedUntilRetake');
      sessionStorage.removeItem('teaQuizHomeReset');
      sessionStorage.removeItem('teaQuizExplicitRetake');
      sessionStorage.removeItem('teaQuizBlockRedirect');
      sessionStorage.removeItem('teaQuizSkipRestore');
      localStorage.removeItem('teaQuizHomeReset');
    } catch (error) {}
    document.documentElement.classList.remove('tea-quiz-at-home');
    if (document.body) document.body.classList.remove('tea-quiz-at-home');
  }

  function clearPersistedQuizState() {
    try {
      if (window.revenueHuntQuizHash && typeof window.revenueHuntQuizHash.clear === 'function') {
        window.revenueHuntQuizHash.clear();
      }
    } catch (error) {}

    try {
      var removeKeys = [];
      var i;
      for (i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (key && StorageKeyPattern.test(key)) removeKeys.push(key);
      }
      removeKeys.forEach(function (storageKey) {
        localStorage.removeItem(storageKey);
      });
    } catch (error) {}

    try {
      var sessionRemoveKeys = [];
      for (i = 0; i < sessionStorage.length; i++) {
        var sessionKey = sessionStorage.key(i);
        if (sessionKey && StorageKeyPattern.test(sessionKey)) sessionRemoveKeys.push(sessionKey);
      }
      sessionRemoveKeys.forEach(function (storageKey) {
        sessionStorage.removeItem(storageKey);
      });
    } catch (error) {}

    clearConstitutionQuizStorage();
  }

  function exitQuizResultsMode() {
    if (window.TeaQuizConstitutionHub && window.TeaQuizConstitutionHub.exitQuizResultsMode) {
      window.TeaQuizConstitutionHub.exitQuizResultsMode();
      return;
    }
    document.documentElement.classList.remove('quiz-results-from-quiz');
    if (document.body) {
      document.body.classList.remove('quiz-results-from-quiz');
    }
    document.querySelectorAll('#quiz,#quiz-container,#shadow-quiz,#quiz #shadow-quiz,#quiz-container #shadow-quiz').forEach(function (node) {
      node.style.removeProperty('display');
    });
    if (window.__teaQuizClearHubRedirectLock) {
      window.__teaQuizClearHubRedirectLock();
    }
  }

  function enableQuizTakeMode() {
    if (window.__teaQuizEnableTakeMode) {
      window.__teaQuizEnableTakeMode();
      return;
    }
    if (window.TeaQuizConstitutionHub && window.TeaQuizConstitutionHub.enableQuizTakeMode) {
      window.TeaQuizConstitutionHub.enableQuizTakeMode();
      return;
    }
    document.documentElement.classList.add('tea-quiz-take-mode');
    exitQuizResultsMode();
  }

  function clickRetakeInRoot(root) {
    var buttons = root.querySelectorAll('button, a, [role="button"]');
    for (var i = 0; i < buttons.length; i++) {
      var label = String(buttons[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (RETakePattern.test(label)) {
        buttons[i].click();
        return true;
      }
    }
    return false;
  }

  function restartInlineQuiz() {
    var restarted = false;
    var hosts = document.querySelectorAll('#shadow-quiz, #quiz #shadow-quiz, #quiz-container #shadow-quiz');

    for (var i = 0; i < hosts.length; i++) {
      if (hosts[i].shadowRoot && clickRetakeInRoot(hosts[i].shadowRoot)) {
        restarted = true;
      }
    }

    if (window.actions) {
      try {
        if (typeof window.actions.retake === 'function') {
          window.actions.retake();
          restarted = true;
        } else if (typeof window.actions.restart === 'function') {
          window.actions.restart();
          restarted = true;
        } else if (typeof window.actions.goToStart === 'function') {
          window.actions.goToStart();
          restarted = true;
        }
      } catch (error) {}
    }

    return restarted;
  }

  function removeTeaQuizInjections() {
    document.querySelectorAll('[data-tea-quiz-injected-popup], [data-tea-quiz-injected-inline]').forEach(function (node) {
      node.remove();
    });

    var hosts = document.querySelectorAll('#shadow-quiz, #quiz #shadow-quiz, #quiz-container #shadow-quiz');
    for (var i = 0; i < hosts.length; i++) {
      if (!hosts[i].shadowRoot) continue;
      hosts[i].shadowRoot.querySelectorAll('[data-tea-quiz-injected-popup], [data-tea-quiz-injected-inline]').forEach(function (node) {
        node.remove();
      });
    }
  }

  function closeRevenueHuntUi() {
    try {
      if (window.revenueHuntQuizPopup && typeof window.revenueHuntQuizPopup.close === 'function') {
        window.revenueHuntQuizPopup.close({ clearHash: true });
      } else if (window.revenueHuntCloseQuizContainer) {
        window.revenueHuntCloseQuizContainer({ clearHash: true });
      }
      if (window.revenueHuntQuizHash && typeof window.revenueHuntQuizHash.clear === 'function') {
        window.revenueHuntQuizHash.clear();
      }
    } catch (error) {}

    var quizContainer = document.getElementById('quiz-container');
    if (quizContainer) quizContainer.remove();

    if (document.body) {
      document.body.classList.remove('revenuehunt-popup-open');
      document.body.style.removeProperty('--quiz-dropdown-z-index');
    }
  }

  function closeCartNotification() {
    var cartNotification = document.querySelector('cart-notification');
    if (cartNotification && typeof cartNotification.close === 'function') {
      try {
        cartNotification.close();
      } catch (error) {}
    }
  }

  function resetQuizUiOnHome() {
    closeRevenueHuntUi();
    clearPersistedQuizState();
    removeTeaQuizInjections();
    restartInlineQuiz();
  }

  function hardNavigateHomeUrl() {
    var cleanRoot = getCleanRootUrl();
    return window.location.origin + cleanRoot + '?_teahome=' + Date.now();
  }

  function goToTopPage() {
    if (window.teaQuizHardGoFreshHome) {
      window.teaQuizHardGoFreshHome();
      return;
    }
    if (window.teaQuizGoToFreshHomepage) {
      window.teaQuizGoToFreshHomepage();
      return;
    }
    closeCartNotification();
    clearSavedConstitutionForLogoHome();
    clearHubNavigationFlags();
    window.__teaQuizResolvedPageMode = 'home';
    window.__teaQuizBlockHubRestore = 1;
    if (window.__teaQuizStopBackgroundPollers) {
      window.__teaQuizStopBackgroundPollers();
    }
    window.location.replace(hardNavigateHomeUrl());
  }

  function bootEarlyHomeReset() {
    if (!shouldApplyQuizHomeResetOnLoad()) return;
    releaseHubModeForLogo();
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname);
    }
    scrollToTopHard();
  }

  function bootLateHomeReset() {
    if (!shouldApplyQuizHomeResetOnLoad()) return;
    releaseHubModeForLogo();
    scrollToTopHard();
  }

  function resetQuizForRetake() {
    allowQuizRestore();
    clearPersistedQuizState();
    removeTeaQuizInjections();
  }

  function markExplicitQuizRetake() {
    try {
      sessionStorage.setItem('teaQuizExplicitRetake', '1');
    } catch (error) {}
  }

  function scrollToQuizSection() {
    if (window.__teaQuizScrollToQuizStart) {
      window.__teaQuizScrollToQuizStart();
      return;
    }
    var quiz = document.getElementById('quiz');
    if (quiz) {
      quiz.scrollIntoView({ behavior: 'auto', block: 'start' });
      return;
    }
    if (window.location.hash !== '#quiz') {
      window.location.hash = 'quiz';
    }
  }

  function scheduleQuizRetakeRestart() {
    window.setTimeout(function () {
      restartInlineQuiz();
      scrollToQuizSection();
    }, 300);
    window.setTimeout(restartInlineQuiz, 1200);
  }

  function bootExplicitQuizRetake() {
    var explicit = false;
    try {
      explicit = sessionStorage.getItem('teaQuizExplicitRetake') === '1';
      if (explicit) sessionStorage.removeItem('teaQuizExplicitRetake');
    } catch (error) {}
    if (!explicit || window.location.hash !== '#quiz') return;
    resetQuizForRetake();
    scrollToQuizSection();
    scheduleQuizRetakeRestart();
  }

  function bootQuizRetakeNavigation() {
    if (
      window.location.search.indexOf('_teaquizretake=') < 0 &&
      window.location.search.indexOf('_teaquiz_start=') < 0
    ) {
      return;
    }
    if (window.__teaQuizClearRedirectGuard) {
      window.__teaQuizClearRedirectGuard();
    }
    try {
      sessionStorage.setItem('teaQuizBlockRedirect', '1');
      sessionStorage.setItem('teaQuizExplicitRetake', '1');
    } catch (error) {}
    resetQuizForRetake();
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname + '?_teaquizretake=1#quiz');
    }
    if (window.__teaQuizScheduleScrollToQuizStart) {
      window.__teaQuizScheduleScrollToQuizStart();
    } else {
      scrollToQuizSection();
    }
    scheduleQuizRetakeRestart();
  }

  function navigateToQuizRetake(event) {
    if (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    if (window.__teaQuizBeginQuizRetakeNavigation) {
      window.__teaQuizBeginQuizRetakeNavigation();
      return;
    }
    if (window.__teaQuizClearRedirectGuard) {
      window.__teaQuizClearRedirectGuard();
    } else if (window.__teaQuizResetQuizSession) {
      window.__teaQuizResetQuizSession();
    }
    markExplicitQuizRetake();
    enableQuizTakeMode();
    clearPersistedQuizState();
    removeTeaQuizInjections();

    var cleanRoot = getCleanRootUrl();
    var retakeUrl = window.location.origin + cleanRoot + (cleanRoot.charAt(cleanRoot.length - 1) === '/' ? '' : '/') + 'pages/taishitsu-check';

    if (isQuizPagePath()) {
      var retakeParam = '_teaquizretake=' + Date.now();
      if (window.location.search.indexOf('_teaquizretake=') >= 0) {
        window.location.reload();
        return;
      }
      window.location.href = retakeUrl + '?' + retakeParam;
      return;
    }

    window.location.href = retakeUrl;
  }

  function findSiteLogoFromEvent(event) {
    var path = event.composedPath ? event.composedPath() : [event.target];
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root_url) || '/';
    var origin = window.location.origin;
    var i;
    for (i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || node === document || node === window || !node.matches) continue;
      if (
        node.matches('a.header__heading-link') ||
        node.matches('a[href="/"]') ||
        node.matches('a[href="' + rootUrl + '"]') ||
        node.matches('a[href="' + origin + '"]') ||
        node.matches('a[href="' + origin + '/"]')
      ) {
        return node;
      }
    }
    var target = event.target;
    if (!target || !target.closest) return null;
    return target.closest('a.header__heading-link');
  }

  function hookSiteLogoClicks() {
    document.addEventListener(
      'click',
      function (event) {
        var logoLink = findSiteLogoFromEvent(event);
        if (!logoLink) return;
        if (logoLink.closest && logoLink.closest('#quiz-container')) return;
        if (logoLink.getAttribute && logoLink.getAttribute('data-tea-quiz-logo-home') === '1') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        goToTopPage();
      },
      true
    );
  }

  function hookQuizIntentLinks() {
    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest(
          'a[href*="#quiz"], a[href*="/#quiz"], a[href*="/pages/taishitsu-check"], a[data-tea-quiz-nav="taishitsu-check"], #taishitsu-check, #taishitsu-check-mobile, .node_taishitsu-check'
        );
        if (!link) return;
        try {
          sessionStorage.setItem('teaQuizExplicitRetake', '1');
          sessionStorage.setItem('teaQuizBlockRedirect', '1');
        } catch (error) {}
        if (window.__teaQuizClearConstitutionResultsStorageSync) {
          window.__teaQuizClearConstitutionResultsStorageSync();
        } else if (window.teaQuizResetState && window.teaQuizResetState.clearPersistedQuizState) {
          window.teaQuizResetState.clearPersistedQuizState();
        }
        navigateToQuizRetake(event);
      },
      true
    );
  }

  function hookQuizHashNavigation() {
    function handleQuizHash() {
      if (window.location.hash !== '#quiz') return;
      if (hasPersistedConstitutionResults()) {
        try {
          if (sessionStorage.getItem('teaQuizExplicitRetake') !== '1' && sessionStorage.getItem('teaQuizBlockRedirect') !== '1') {
            if (window.__teaQuizRestoreHubAfterNavigation) {
              window.__teaQuizRestoreHubAfterNavigation();
              return;
            }
          }
        } catch (error) {}
      }
      if (isHubResultsUrlNow() && hasPersistedConstitutionResults()) return;

      enableQuizTakeMode();

      try {
        if (new URLSearchParams(window.location.search).get('view') === 'quiz-results') {
          var cleanPath = getCleanRootUrl();
          window.history.replaceState(null, '', cleanPath + '#quiz');
        }
      } catch (error) {}

      exitQuizResultsMode();
      try {
        if (
          sessionStorage.getItem('teaQuizExplicitRetake') === '1' ||
          sessionStorage.getItem('teaQuizBlockRedirect') === '1' ||
          window.location.search.indexOf('_teaquizretake=') >= 0
        ) {
          clearConstitutionQuizStorage();
        }
      } catch (error) {}
    }

    window.addEventListener('hashchange', handleQuizHash);
    handleQuizHash();
  }

  window.teaQuizResetState = {
    goToTopPage: goToTopPage,
    applyHomeReset: goToTopPage,
    bootEarlyHomeReset: bootEarlyHomeReset,
    bootLateHomeReset: bootLateHomeReset,
    allowQuizRestore: allowQuizRestore,
    resetQuizForRetake: resetQuizForRetake,
    navigateToQuizRetake: navigateToQuizRetake,
    shouldBlockQuizRestore: shouldBlockQuizRestore,
    shouldApplyQuizHomeResetOnLoad: shouldApplyQuizHomeResetOnLoad,
    quizResultsVisibleOnPage: quizResultsVisibleOnPage,
    clearPersistedQuizState: clearPersistedQuizState,
    exitQuizResultsMode: exitQuizResultsMode,
    restartInlineQuiz: restartInlineQuiz,
    removeTeaQuizInjections: removeTeaQuizInjections,
    scrollToTopHard: scrollToTopHard,
    markQuizHomeReset: markQuizHomeReset,
    releaseHubModeForLogo: releaseHubModeForLogo,
    isOnHomePath: isOnHomePath
  };

  window.teaQuizGoToTopPage = goToTopPage;
  window.teaQuizApplyHomeReset = goToTopPage;
  window.teaQuizGoHome = goToTopPage;
  window.teaQuizCloseAndReturnHome = goToTopPage;
  if (!window.teaQuizGoToFreshHomepage) {
    window.teaQuizGoToFreshHomepage = goToTopPage;
  }

  bootEarlyHomeReset();
  bootQuizRetakeNavigation();
  document.addEventListener('DOMContentLoaded', bootLateHomeReset);
  document.addEventListener('DOMContentLoaded', bootQuizRetakeNavigation);
  window.addEventListener('load', bootLateHomeReset);
  window.addEventListener('load', bootQuizRetakeNavigation);
  hookQuizIntentLinks();
  hookQuizHashNavigation();
  hookSiteLogoClicks();
})();
